import { render, staticRenderFns } from "./UpdateReminder.vue?vue&type=template&id=c8a5a6f0"
import script from "./UpdateReminder.vue?vue&type=script&lang=js"
export * from "./UpdateReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports